/**
 * Configuration centralisée du frontend
 * Toutes les variables d'environnement critiques sont validées ici
 */

// Validation de REACT_APP_BACKEND_URL
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

if (!BACKEND_URL) {
  const errorMessage = `
❌ ERREUR CRITIQUE: REACT_APP_BACKEND_URL n'est pas défini!

Pour corriger ce problème:
1. Créez un fichier .env à la racine du dossier frontend
2. Ajoutez: REACT_APP_BACKEND_URL=http://localhost:8001
3. Redémarrez l'application

Ou copiez le fichier .env.example:
cp .env.example .env
`;
  console.error(errorMessage);
  throw new Error('REACT_APP_BACKEND_URL est obligatoire. Vérifiez votre fichier .env');
}

// Export des constantes
export { BACKEND_URL };
export const API_URL = `${BACKEND_URL}/api`;
